<template>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.45 48.65">


        <path class="vdh-wic-cls-2"
            d="M0,1.44c.33-.16.56-.52.89-.66,1.15-.49,8.2-.46,9.77-.3.95.1,2.13.6,2.62,1.46.56.98,1.06,5.58,1.3,7.07,1.36,8.3,2.41,16.66,3.75,24.96,1.71-10.68,3.53-21.37,5.58-31.99.45-.94,1.57-1.4,2.57-1.51,2.09-.21,6.79-.22,8.87,0,1.97.21,2.55,1.29,2.93,3.06,1.01,4.73,1.69,10.21,2.42,15.04s1.49,10.08,1.96,15.15l4.62-29.71c.17-1.87.96-3.25,2.95-3.52,1.82-.24,6.01-.19,7.9-.03,1.17.1,2.34.44,2.29,1.8l-10.63,43.48c-.56,1.33-1.47,1.98-2.93,2.1-2.25.19-7.42.26-9.58-.03-.97-.13-1.63-.66-2.11-1.48-1.92-9.97-3.69-19.99-4.86-30.07-.19,0-.29.66-.33.87-1.84,9.19-2.6,18.74-4.94,27.84-.4,1.54-.83,2.67-2.63,2.87-2.19.25-7.89.25-10.08,0-2.49-.28-2.61-2.61-3.11-4.55L0,3.59V1.44Z" />
        <path class="vdh-wic-cls-3"
            d="M110.49,0c2.98.98,7.43-.12,6.93,4.4-.11.96-1.11,5.2-1.54,5.87-1.42,2.23-4.71.42-6.94.25-7.88-.59-14.16,2.71-15.43,10.91-1.64,10.54,5.01,17.04,15.44,16.37,2.07-.13,6.01-1.82,6.95.93.25.71,1.11,5.65,1.08,6.35-.07,2.01-1.81,2.29-3.37,2.64-13.39,3.02-29.38-1.1-33.01-15.86-3.82-15.52,5.17-30.34,21.5-31.86h8.39Z" />
        <path class="vdh-wic-cls-1"
            d="M65.61.53c1.56-.28,7.17-.25,8.79-.04.97.13,1.7.64,2.01,1.58l.06,43.98c0,.7-.98,1.59-1.62,1.73-1.16.26-7.99.23-9.28.04-.7-.11-1.62-.61-1.76-1.35l.07-44.8c.46-.58.98-1.01,1.73-1.14Z" />
    </svg>

</template>
<style>
.vdh-wic-cls-1 {
    fill: #ee3439;
}

.vdh-wic-cls-2 {
    fill: #2cb34a;
}

.vdh-wic-cls-3 {
    fill: #2e3192;
}

.draw-border:hover .vdh-wic-cls-1,
.draw-border:hover .vdh-wic-cls-2,
.draw-border:hover .vdh-wic-cls-3 {
    fill: currentColor !important;

}

:deep(.vdh-wic-cls-1),
:deep(.vdh-wic-cls-2),
:deep(.vdh-wic-cls-3) {
    transition: fill .2s ease;
}

/* .vdh-wic-cls-1:hover,
.vdh-wic-cls-2:hover,
.vdh-wic-cls-3:hover {
    fill: currentColor;
}

.vdh-wic-cls-1:hover::before,
.vdh-wic-cls-1:hover::after,
.vdh-wic-cls-2:hover::before,
.vdh-wic-cls-2:hover::after,
.vdh-wic-cls-3:hover::before,
.vdh-wic-cls-3:hover::after {
    fill: currentColor;
} */
</style>

<script>
export default {
    name: 'vdhWicLogo',
}
</script>
